export node from './node';
export web from './web';
export generateConfig, { cwd } from './generateConfig';
export * as plugins from './plugins';
export * as helpers from './helpers';
export * as rules from './rules';

export const MODES = {
  development: 'development',
  production: 'production',
};
